/* EyvaX video feature: plays while on screen, pauses off screen; the visitor's
   own pause is remembered. */
(function () {
  'use strict';
  var Eyvax = window.Eyvax;
  if (!Eyvax) return;

  function EyvaxVideo() {
    return Reflect.construct(Eyvax.Section, [], EyvaxVideo);
  }
  EyvaxVideo.prototype = Object.create(Eyvax.Section.prototype);
  EyvaxVideo.prototype.constructor = EyvaxVideo;

  EyvaxVideo.prototype.init = function () {
    var self = this;
    var v = this.querySelector('video');
    var btn = this.querySelector('.ex-film__btn');
    if (!v) {
      if (btn) btn.hidden = true;
      return;
    }
    var auto = this.getAttribute('data-autoplay') === 'true' && !Eyvax.reduced();
    var userPaused = !auto;
    var inView = false;

    function play() {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    function label() {
      if (!btn) return;
      var paused = v.paused;
      btn.setAttribute('aria-pressed', String(paused));
      btn.querySelector('.ex-film__btn-t').textContent = paused ? btn.getAttribute('data-play-label') : btn.getAttribute('data-pause-label');
    }
    function sync() {
      if (inView && !userPaused && !document.hidden) play();
      else v.pause();
      label();
    }

    v.addEventListener('play', label, { signal: this.signal });
    v.addEventListener('pause', label, { signal: this.signal });

    if (btn) {
      btn.addEventListener(
        'click',
        function () {
          userPaused = !v.paused;
          if (userPaused) v.pause();
          else play();
          label();
        },
        { signal: this.signal }
      );
    }

    var off = Eyvax.onVisible(
      this,
      function (vis) {
        inView = vis;
        sync();
      },
      { threshold: 0.25 }
    );
    document.addEventListener('visibilitychange', sync, { signal: this.signal });
    this.signal.addEventListener('abort', function () {
      off();
      v.pause();
    });
    label();
  };

  Eyvax.define('eyvax-video', EyvaxVideo);
})();
